import React, { useEffect, useState } from 'react';
// material-ui
import { Typography } from '@mui/material';
import axios from 'axios';

// project imports
import NavGroup from './NavGroup';

import getSidebarItems from '../../../../menu-items/other';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const [, setMenuTick] = useState(0);
    useEffect(() => {
        const refresh = () => setMenuTick((n) => n + 1);
        window.addEventListener('userDataUpdated', refresh);
        return () => window.removeEventListener('userDataUpdated', refresh);
    }, []);

    useEffect(() => {
        axios.get('/api2/v2/accunt/me/').then((res) => {
            const user = res.data?.data?.user;
            if (!user) return;
            const current = JSON.parse(localStorage.getItem('userData') || '{}');
            localStorage.setItem('userData', JSON.stringify({ ...current, ...user }));
            window.dispatchEvent(new Event('userDataUpdated'));
        }).catch(() => {});
    }, []);

    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    // Eski oturum rolleri (ortherouser/adviser) adviser menüsüne düşsün — drawer asla boş kalmasın
    const FALLBACK_ROLES = { ortherouser: 'ortheroadviser', adviser: 'ortheroadviser' };
    const role = FALLBACK_ROLES[userData?.role] || userData?.role || 'default';
    const navItems = [getSidebarItems(role)].map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
